import { IonAvatar, IonBadge, IonButton, IonButtons, IonCard, IonContent, IonIcon, IonItem, IonLabel, IonList, IonPage, IonSearchbar, IonToolbar, withIonLifeCycle } from "@ionic/react";
import React from "react";
import AcrofitHeader from "../components/AcrofitHeader";
import IAlimento from "../interfaces/IAlimento";

import fondo_ingredientes from "../images/banners/fondo_ingredientes.jpg"
import fondo_light from "../images/banners/fondo_light.jpg"
import fondo_normal from "../images/banners/fondo_normal.jpg"
import fondo_tipica from "../images/banners/fondo_tipica.jpg"
import fondo_bebidas from "../images/banners/fondo_bebidas.jpg"
import fondo_snacks from "../images/banners/fondo_snacks.jpg"
import alimento_gen from "../images/alimento_gen.svg"
import { syncAlimentos } from "../components/Funciones";
import db from "../components/Database";
import { matchSorter } from "match-sorter";
import { arrowBack, sad } from "ionicons/icons";
import AgregarAlimentos from "../components/AddAlimento";
import moment from "moment";

class AlimentosPage extends React.Component{

    timeout = null as any

    state = {
        items:[] as Array<IAlimento>,
        categoria:null as string|null,
        alimento:undefined as IAlimento|undefined,
        busqueda:"",
        isOpen:false
    }

    async ionViewDidEnter(){
        await syncAlimentos()
    }

    buscarChange = async (e:any) => {
      await this.setState({busqueda:e.target.value})
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.buscar(),300)
    }
  
    buscar = async () => {
      const {busqueda,categoria} = this.state
      const items_tmp = await db.alimentos.filter(p => p.estado == "A" && p.categoria == categoria).toArray()
      const items = matchSorter(items_tmp,busqueda,{keys:["nombre"]})
      await this.setState({items})
    }

    setCategoria = async (categoria:string) => {
        await this.setState({categoria,busqueda:""})
        await this.buscar()
    }

    selectItem = (alimento:IAlimento) => {
        this.setState({alimento,isOpen:true})
    }

    onSaveAlimento = () => {
        window.location.href = "/registro"
    }

    render(){
        const {categoria,items,busqueda,isOpen,alimento} = this.state
        return (
            <IonPage>
                <AcrofitHeader>
                    {
                        categoria && (
                            <IonToolbar>
                                <IonButtons slot="start">
                                    <IonButton onClick={e => this.setState({categoria:null,busqueda:null})}><IonIcon icon={arrowBack} /></IonButton>
                                </IonButtons>
                                <IonSearchbar placeholder="Buscar" value={busqueda} onIonChange={this.buscarChange} />
                            </IonToolbar>
                        )
                    }
                </AcrofitHeader>
                <IonContent className="no-bg">
                    {
                        categoria?(
                            <IonList className="no-bg">
                                {
                                    items.length>0?
                                    items.map((alimento,i) => (

                                    <IonItem key={i} button onClick={() => this.selectItem(alimento)} className="transparent">
                                        <IonAvatar slot="start">
                                            <img src={alimento.foto||alimento_gen} />
                                        </IonAvatar>
                                        <IonLabel>
                                            <small><b>{alimento.porcion}</b></small>
                                            <h2>{alimento.nombre} </h2>
                                            {alimento.equivalencia?
                                                <p>{alimento.equivalencia}</p>
                                            :null}
                                        </IonLabel>
                                        <IonBadge slot="end">{alimento.calorias} cal</IonBadge>
                                    </IonItem>
                                    ))
                                    :<IonItem lines="none"><span style={{textAlign:"center"}}><IonIcon icon={sad} /> No existen datos para su búsqueda</span></IonItem>
                                }
                            </IonList>
                        ):(
                            <IonList lines="none" className="no-bg">
                                <IonCard button onClick={e => this.setCategoria("T")} >
                                    <img src={fondo_tipica}  />
                                </IonCard>
                                <IonCard onClick={e => this.setCategoria("L")} button>
                                    <img src={fondo_light}  />
                                </IonCard>
                                <IonCard button onClick={e => this.setCategoria("N")}>
                                    <img src={fondo_normal}  />
                                </IonCard>
                                <IonCard button onClick={e => this.setCategoria("I")}>
                                    <img src={fondo_ingredientes}  />
                                </IonCard>
                                <IonCard  button onClick={e => this.setCategoria("B")}>
                                    <img src={fondo_bebidas}  />
                                </IonCard>
                                <IonCard button onClick={e => this.setCategoria("S")}>
                                    <img src={fondo_snacks}  />
                                </IonCard>
                            </IonList>
                        )
                    }
                </IonContent>
                <AgregarAlimentos isOpen={isOpen} alimento={alimento} fecha={moment().format()} onSave={this.onSaveAlimento} onClose={() => this.setState({isOpen:false})} />
            </IonPage>
        )
    }
}

export default withIonLifeCycle(AlimentosPage)